<template>
  <v-card
    class="item-card ml-2 mr-2"
    flat
  >
    <div class="mt-2 mb-2 pl-2 pr-2">
      <center>
        <v-avatar size="80">
          <!-- {{ avatar }} -->
          <v-img
            v-if="isError"
            max-height="128"
            max-width="128"
            contain
            :src="accountImage"
          >
          </v-img>
          <v-img
            v-else
            :src="avatar"
            @error="handleError"
          ></v-img>
        </v-avatar>
        <h3 class="font-weight-bold">
          {{ userData.fullName }}
        </h3>
        <div>
          {{ userData.mobileNo }}
        </div>
        <div>
          {{ userData.userNo }}
        </div>
      </center>
    </div>
  </v-card>
</template>
<script setup>
import { ref, computed, toRefs } from 'vue'

const isError = ref(false)
function handleError(e) {
  isError.value = true
}

const accountImage = computed(() => require('@/assets/images/AsianAlliance/account-circle.png'))

const props = defineProps({
  userData: {
    type: Object,
    default() {
      return {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
        nickName: 'Jason',
        mobileNo: '98765431',
        userNo: 'AM-202301001',
      }
    },
  },
})
const { userData } = toRefs(props)
const avatar = computed(() => process.env.VUE_APP_BASE_API + userData.value.avatar || 'https://cdn.vuetifyjs.com/images/lists/1.jpg')

const error = ref(false)

</script>
<style scoped>
.item-card{
  display: inline-block !important;
  white-space: nowrap;
  cursor: pointer;
}
</style>
